import { withInstall } from "../utils/index.mjs";
import _Tag from "./Tag.mjs";
const Tag = withInstall(_Tag);
var stdin_default = Tag;
import { tagProps } from "./Tag.mjs";
export {
  Tag,
  stdin_default as default,
  tagProps
};
